import { useState } from "react";
import { motion } from "framer-motion";
import { Megaphone } from "lucide-react";
import SubmitModal from "@/components/home/SubmitModal";

export default function SubmitSection({ cities }) {
  const [open, setOpen] = useState(false);

  return (
    <section className="border-t border-white/10 bg-[#0E1117]" data-testid="submit-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-5 py-16 sm:flex-row sm:items-center sm:px-8"
      >
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.35em] text-neon-amber">06 // Community Intel</div>
          <h2 className="mt-3 font-editorial text-2xl uppercase tracking-wide sm:text-3xl">Know a spot we don&apos;t?</h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-zinc-400">
            Promoters, bartenders, night owls — tip us off to the basement show or the 4AM window
            only locals know. A human reviews every submission before it goes live.
          </p>
        </div>
        <button
          onClick={() => setOpen(true)}
          data-testid="submit-open-button"
          className="inline-flex shrink-0 items-center gap-3 rounded-full border border-neon-amber/50 px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-neon-amber transition-all hover:-translate-y-1 hover:bg-neon-amber hover:text-black hover:shadow-[0_0_36px_rgba(245,158,11,0.4)]"
        >
          <Megaphone className="h-4 w-4" /> Submit a Spot or Event
        </button>
      </motion.div>
      <SubmitModal open={open} onClose={() => setOpen(false)} cities={cities} />
    </section>
  );
}
